import { render, staticRenderFns } from "./MyPortfolio.vue?vue&type=template&id=a3abed66&"
import script from "./MyPortfolio.vue?vue&type=script&lang=js&"
export * from "./MyPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./MyPortfolio.vue?vue&type=style&index=0&id=a3abed66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports